import React from "react";
import Section2 from "../ui/Entreprise/Section2";
import Section4 from "../ui/Entreprise/Section4";
import Section1 from "../ui/Entreprise/section1";
import Section3 from "../ui/Entreprise/section3";
import HelmetComponent from "../component/HelmetComponent";
import translator from "../../Components/Extra/Translation/Translate";

export default function Entreprise() {
    const { translate } = translator();
    return (
        <>
            <HelmetComponent
                title={translate("SEO", "Entreprise_title")}
                description={translate("SEO", "Entreprise_desc")}
                link="/buys"
                keywords={translate("SEO", "Entreprise_keywords")}
                imageCard="/dist/image/clishanodes-cards-1024x1024.png"
                largeTwitterCard="/dist/image/clishanodes-cards-1024x1024.png"
                addPostfixTitle={true}
                noIndex={false}
            ></HelmetComponent>

            <Section1 />
            <Section2 />
            <Section3 />
            <Section4 />
        </>
    );
}
